<template lang="pug">
  v-popover(
    trigger='manual'
    :delay='0'
    popoverClass="topics"
    :open='active'
    placement="bottom-start"
  )
    .row.middle
      simple-svg.m-right-1(:filepath='topicsIcon' width='20px' height='20px')
      .row.middle
        .topic.row.middle(
          v-for='(subtopic, index) in subtopicsList.slice(0, 2)'
          :class='{divider: index > 0 && subtopicsList.length > 1}'
        )
          h3.topic-name.text-normal.dark-gray.bold {{ subtopic.topic.name }}
          h3.subtopic-name.text-normal.dark-gray(v-if='subtopic.name !== subtopic.topic.name')
            | {{ `: ${subtopic.name}` }}
        button.topic.row.middle.divider(v-if='subtopicsList.length > 2' @click='toggleMore')
          h3.text-normal.dark-gray
            | {{ $tc('presentationTab.moreTopics', (subtopicsList.length - 2)) }}
    template(slot='popover')
      .column
        .row.middle.m-bottom-2
          simple-svg(:filepath='topicsIcon' width='20px' height='20px')
          h2.title-small.m-left-1 {{ $t('presentationTab.topicsAssociated') }}
        ul.list
          li.row.middle.list-item(v-for='topic in parsedTopics')
            h3.topic.dark-gray.text-normal.bold {{ topic.name }}
            h3.subtopics.dark-gray.text-normal(v-if='topic.subtopics[0] !== topic.name')
              | {{ `: ${topic.subtopics.join(', ')}` }}
</template>

<script>
import topicsIcon from '@/assets/ic_topics.svg'
import { mapState } from 'vuex'

export default {
  props: {
    subtopics: { type: Array }
  },
  data() {
    return {
      active: false,
      topicsIcon
    }
  },
  computed: {
    ...mapState({
      topics: state => state.dashboard.topics
    }),
    subtopicsList() {
      const subtopics = []
      this.parsedTopics.forEach(topic => {
        topic.subtopics.forEach(sub => {
          subtopics.push({
            name: sub,
            topic: {
              name: topic.name,
              id: topic.id
            }
          })
        })
      })
      return subtopics
    },
    parsedTopics() {
      return this.topics
        .filter(topic => topic.subtopics.some(sub => this.subtopics.includes(sub.id)))
        .map(topic =>
          ({
            ...topic,
            subtopics: topic.subtopics
              .filter(sub => this.subtopics.includes(sub.id))
              .map(sub => sub.name)
          })
        )
    }
  },
  methods: {
    toggleMore() {
      this.active = !this.active
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/variables/colors';

.topic{
  &.divider{
    margin-left: 8px;
    &::before{
      margin-right: 8px;
      margin-top: 3px;
      display: block;
      content: "";
      width: 8px;
      height: 8px;
      background-color: $blue;
      border-radius: 50%;
    }
  }
}
.list{
  &>*:not(:last-child){
    margin-bottom: 5px;
  }
  .list-item::before{
      margin-right: 8px;
      margin-top: 3px;
      display: block;
      content: "";
      width: 8px;
      height: 8px;
      background-color: $dark-gray;
      border-radius: 50%;
  }
}
</style>
